import { SVGProps } from "react";

export function TriangleInvertedFilled(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14px"
      height="14px"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.118 3H3.893A2.914 2.914 0 0 0 1.39 7.371L9.506 20.92a2.917 2.917 0 0 0 4.987.005l8.11-13.539A2.914 2.914 0 0 0 20.117 3z"
      ></path>
    </svg>
  )
}
